import script from "./recipe-selector.vue?vue&type=script&setup=true&lang=js"
export * from "./recipe-selector.vue?vue&type=script&setup=true&lang=js"

import "./recipe-selector.vue?vue&type=style&index=0&id=41619123&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41619123"]])

export default __exports__